/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MockERC20, MockERC20Interface } from "../MockERC20";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "mintTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class MockERC20__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _name: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockERC20> {
    return super.deploy(_name, overrides || {}) as Promise<MockERC20>;
  }
  getDeployTransaction(
    _name: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, overrides || {});
  }
  attach(address: string): MockERC20 {
    return super.attach(address) as MockERC20;
  }
  connect(signer: Signer): MockERC20__factory {
    return super.connect(signer) as MockERC20__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockERC20Interface {
    return new utils.Interface(_abi) as MockERC20Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockERC20 {
    return new Contract(address, _abi, signerOrProvider) as MockERC20;
  }
}
